import "../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22src%2Fcomponents%2FIconButton%2FIconButton.css.ts.vanilla.css%22%2C%22source%22%3A%22Lmp2dWs4bjEgewogIGZvbnQtc2l6ZTogMS41ZW07Cn0%3D%22%7D"
export var icon = 'jvuk8n1';
export var root = 'jvuk8n0';